import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter030() {
  return <KbChapterPage slug="chapter-030" />;
}

(Chapter030 as unknown as { path: string }).path = "/theory-album/030";
